import {
    instance as axios,
    setJwtToken,
  } from "../../config/axiosInstance";
  
export const sleepTrackingListApi = async (data) => {
  const endPoint = `admin/sleep-tracking/list?${new URLSearchParams(
    data
  ).toString()}`;
  return await axios.get(endPoint, setJwtToken());
};
